<script setup lang="ts">
interface Props {
  loading: boolean
}

defineProps<Props>()
</script>

<template>
  <div class="w-full h-1 overflow-hidden" :class="loading ? 'visible bg-gray-300' : 'bg-transparent invisible'">
    <div class="bg-linear-to-l from-brand-contrast to-gray-300 animate-progress w-full h-full origin-left"></div>
  </div>
</template>
